// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DragDrop = require("./DragDrop");

var make = DragDrop.DropArea;

var DropArea = {
  make: make
};

var make$1 = DragDrop.DragDropContext;

var DragDropContext = {
  make: make$1
};

exports.DropArea = DropArea;
exports.DragDropContext = DragDropContext;
/* make Not a pure module */
